import { AppInsightsContext, withAITracking } from '@microsoft/applicationinsights-react-js';
import { reactPlugin } from '../../AppInsights';
import TokenService from './TokenService';
import CallBackServiceSACBL from './callback.serviceSACBL';

const CallBackServiceSACBLWrapper: React.FC = () => (
  <AppInsightsContext.Provider value={reactPlugin}>
    <CallBackServiceSACBL tokenService={new TokenService()} />
  </AppInsightsContext.Provider>
);
export default withAITracking(reactPlugin, CallBackServiceSACBLWrapper);
